import { FormControlLabel, Switch, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { ProviderConnectionsBookingItem } from '../../types/accommodationProviderSubmit'

export function bookingNotesEnabledForAdapter(
  connection: ProviderConnectionsBookingItem,
  nextAdapter: string
): boolean {
  return (
    connection.providerAdapter === nextAdapter &&
    connection.pmsConnected === true &&
    (connection.bookingNotesSupportedAdapters || []).includes(nextAdapter) &&
    connection.bookingNotesEnabled === true
  )
}

export default function BookingNotesSwitch({
  connection,
  onChange,
  descriptionId
}: {
  connection: ProviderConnectionsBookingItem
  onChange: (enabled: boolean) => void
  descriptionId: string
}) {
  const supported =
    (connection.bookingNotesSupportedAdapters || []).includes(
      connection.providerAdapter
    ) && connection.pmsConnected === true
  return (
    <div>
      <FormControlLabel
        label={getTranslate('Send booking notes to PMS')}
        control={
          <Switch
            color="primary"
            checked={supported && connection.bookingNotesEnabled === true}
            disabled={!supported}
            onChange={(_, checked) => onChange(checked)}
            inputProps={{
              'aria-label': getTranslate('Send booking notes to PMS'),
              'aria-describedby': !supported ? descriptionId : undefined
            }}
          />
        }
      />
      {!supported && (
        <Typography id={descriptionId} variant="caption" component="p">
          {getTranslate(
            !(connection.bookingNotesSupportedAdapters || []).includes(
              connection.providerAdapter
            )
              ? 'Booking notes are not supported by this PMS connection'
              : 'Connect the booking connection to PMS first'
          )}
        </Typography>
      )}
    </div>
  )
}
